<template>
  <li>
    <!---->
    <span class="waypoints-list-item _flxrcs">
      <i class="waypoints-list-item__icon material-icons">
        {{metaData.icon}}
      </i>
      <div class="waypoints-list-item__label">
        {{label}}
      </div>
      <div class="waypoints-list-item__expand-button" @click="areValuesVisible = !areValuesVisible">
        <i v-if="areValuesVisible" class="material-icons" >
          expand_less
        </i>
        <i v-else class="material-icons" >
          expand_more
        </i>
      </div>
    </span>
    <!---->
    <span v-if="areValuesVisible" class=" _flxrcs">
      <span class="waypoints-list-item__label">
      x
      </span>
      <input type="text" maxlength="4" v-model="wpx" class="waypoints-list-item__input"/>
      <span class="waypoints-list-item__label">
      y
      </span>
      <input type="text" maxlength="4"  v-model="wpy" class="waypoints-list-item__input"/>
      <span class="waypoints-list-item__label"> 
      w
      </span >
      <input type="text" maxlength="4"  v-model="wpw" class="waypoints-list-item__input"/>
      <span class="waypoints-list-item__label">
      h
      </span>
      <input type="text" maxlength="4"  v-model="wph" class="waypoints-list-item__input"/>
    </span>
    <!---->
  </li>
</template>

<script>
import { mapState } from 'vuex'
import { metaDataFormDefaults, metaDataFormDefaultsFor } from '../metadataFormFields'

export default {
  name: 'waypointsListItem',

  props: {
    waypoint : {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data() {
    return {
      areValuesVisible: true
    }
  },

  computed: {
  ...mapState(['video']),

    metaData: function () {
      const template = this.waypoint.tag.template || 'ptag'

      const metaData = metaDataFormDefaults().find(mdfd => {
        return mdfd.key === template
      })

      return metaData || { icon: 'done', label: 'Waypoint' }
    },

    label: function () {
      const tag = this.waypoint.tag

      return tag.name !== 'New Tag' ? tag.name : (metaDataFormDefaultsFor(tag.template) || {}).label
    },

    wpx: {
      get: function () {
        return Math.min(
          this.video.dimensions.width,
          Math.round(this.video.dimensions.width * this.waypoint.wp.x)
        )
      },

      set: function (value) {
        value = parseInt(value)

        this.waypoint.wp.x = value / this.video.dimensions.width
      }
    },

    wpy: {
      get: function () {
        return Math.min(
          this.video.dimensions.height,
          Math.round(this.video.dimensions.height * this.waypoint.wp.y)
        )
      },

      set: function (value) {
        value = parseInt(value)

        this.waypoint.wp.y = value / this.video.dimensions.height
      }
    },
  
    wpw: {
      get: function () {
        return Math.min(
          this.video.dimensions.width,
          Math.round(this.video.dimensions.width * this.waypoint.wp.pw)
        )
      },

      set: function (value) {
        const minSize = 32
        value = parseInt(value)

        this.waypoint.wp.w = value > minSize ? value : minSize
        this.waypoint.wp.pw = value / this.video.dimensions.width
      }
    },

    wph: {
      get: function () {
        return Math.min(
          this.video.dimensions.height,
          Math.round(this.video.dimensions.height * this.waypoint.wp.ph)
        )
      },

      set: function (value) {
        const minSize = 32
        value = parseInt(value)

        this.waypoint.wp.h = value > minSize ? value : minSize
        this.waypoint.wp.ph = value / this.video.dimensions.height
      }
    }
  }
}
</script>
